import React from 'react'
function Hero() {
    return ( 
        <div className="container">
            <div className="row border-bottom ">
                <h1 className="text-center mt-5">Pricing</h1>
                <p className="text-muted text-center mb-5">Free equity investment and flat &#8377;20 traday anf F&O trades</p>
            </div> 
            <div className="row mt-5">
                <div className="col">
                    <img src='media/images/pricingEquity.svg' alt='Pricing Hero Image' />
                    <h1>Free equity delivery</h1>
                    <p className="text-muted">All equity delivery investments (NSE, BSE), are absolutely free brokerage.</p>
                </div>
                <div className="col">
                    <img src='media/images/intradayTrades.svg' alt='Pricing Hero Image' />
                    <h1>Intraday and F&O trades</h1>
                    <p className="text-muted">Flat Rs. 20 or 0.03% (whichever is lower) per executed order on intraday trades across equity, currency, and commodity trades.</p>
                </div>
                <div className="col">
                    <img src='media/images/pricingEquity.svg' alt='Pricing Hero Image' />
                    <h1>Free direct MF</h1>
                    <p className="text-muted">All investments in direct mutual funds through Coin are free of cost. No account opening or annual maintenance charges.</p>
                </div>
            </div>
        </div>
     );
}

export default Hero;